import css from './ForceScroll.less'
import type {ReactNode} from 'react'

interface ForceScrollProps {
    children: ReactNode
}

export default function ForceScroll({children}: ForceScrollProps) {
    return (
        <div className={css.a}>
            <div className={css.b}>{children}</div>
        </div>
    )
}
